module.exports = __webpack_public_path__ + "static/media/WEF-norming-Intro-upper.9394cb7b.mp3";